import setWithExpiry from './lib/set-with-expiry.js';
import getWithExpiry from './lib/get-with-expiry.js';
import addParameter from './lib/add-parameter.js';
import keys from './lib/keys.js';

let tracking = {
    addTrackingParameters: function(url, trackingParameters = {}) {

        const first = getWithExpiry(keys.first);
        const last = getWithExpiry(keys.last);
        const sg = getWithExpiry(keys.sgTracking);

        if(first) {
            url = addParameter(url, 'landing', first);
        }

        if(last) {
            url = addParameter(url, 'referer', last);
        }

        if(sg) {
            url = addParameter(url, sg.name, sg.value);
        }

        Object.keys(trackingParameters).forEach(key => {
            if (['placement', 'position'].includes(key)) {
                url = addParameter(url, key, trackingParameters[key]);
            }
        });

        return url;
    },

    getTrackingObject: function() {

        const first = getWithExpiry(keys.first);
        const last = getWithExpiry(keys.last);
        const sg = getWithExpiry(keys.sgTracking);

        let tracking = {};

        if (first) {
            tracking.landing = first;
        }

        if (last) {
            tracking.referer = last;
        }

        if (sg) {
            tracking[sg.name] = sg.value;
        }

        return tracking;
    }
}

export default ({ app }, inject) => {

    app.context.$tracking = tracking;
    inject('tracking', tracking);

    // do the first / last page tracking
    app.router.afterEach((to, from) => {
        
        // TODO: Fix for Kortio, should probably be passed as option or similar
        if(!to.path.includes('out') && !to.path.match('\/kort\/[a-zA-Z0-9].*\/ansok\/')) {
            if(!getWithExpiry(keys.first)) {
                setWithExpiry(keys.first, to.path);
            }
            setWithExpiry(keys.last, to.path);
        }
    });

    var searchParams = new URLSearchParams(window.location.search);

    if(searchParams.has('gclid')) {
        setWithExpiry(keys.sgTracking, {
            name: 'gclid', value: searchParams.get('gclid')
        });
    }
    else if(searchParams.has('sgid')) {
        setWithExpiry(keys.sgTracking, {
            name: 'sgid', value: searchParams.get('sgid')
        });
    }
    else if(searchParams.has('msclkid')) {
        setWithExpiry(keys.sgTracking, {
            name: 'msclkid', value: searchParams.get('msclkid')
        });
    }
}